import { useNavigate } from 'react-router-dom'
import { Box } from '@material-ui/core'
import { ROUTES } from '../../../../constants'
import { IInvoice } from 'models/invoices.models'
import CFDIFinderContainer from 'containers/Invoices/NewCFDI/CFDIFinderContainer/CFDIFinderContainer'

const NewPaymentComplementScreen = () => {
  const navigate = useNavigate()
  const handleOnSelect = (invoice: IInvoice) => {
    const { idCfdi, version } = invoice

    const urlVersion = parseFloat(String(version)) >= 4 ? '4.0' : '3.3'

    navigate(
      `${ROUTES.ADD_PAYMENT_COMPLEMENT.replace(':invoice', `${idCfdi}`).replace(':version', urlVersion)}`
    )
  }
  return (
    <Box width="100%" paddingX={8}>
      <CFDIFinderContainer
        onSelect={handleOnSelect}
        title="Nuevo complemento de pago"
        subtitle="Selecciona la factura a la cual se le aplicará el complemento de pago:"
      />
    </Box>
  )
}

export default NewPaymentComplementScreen
